import React, {Component} from "react";
import {connect} from "react-redux";
import {Translate} from "react-i18nify";

import * as navigationActions from "../../../../../actions/navigationActions";
import * as componentTypes from "../../../../../constants/componentTypes";
import * as actions from "../../../../../actions/intergammaMachineActions";

class DeleteOrderModal extends Component {
    handleCloseModalClick = () => {
        this.props.dispatchCloseDeleteOrderModalAction();
    };

    handleNoButtonClick = () => {
        this.props.dispatchCloseDeleteOrderModalAction();
    };

    handleYesButtonClick = () => {
        this.props.dispatchDeleteOrderAction(this.props.activeOrder);
    };

    render() {
        return (
            <div id="modal" className="default-modal ig-delete-order-modal ig-small-modal">
                <div className="modal-content">
                    <div className="col-xs-12 ">
                        <Translate value="dialog.reallyDeleteOrder" />
                    </div>
                    <div className="modal-footer">
                        <div className="col-xs-6 text-right">
                            <button className="btn btn-danger btn-md btn-arrow" onClick={this.handleNoButtonClick}>
                                <span className="glyphicon glyphicon-menu-right" />
                                <Translate value="general.no" />
                            </button>
                        </div>
                        <div className="col-xs-6 text-left ">
                            <button className="btn btn-danger btn-md btn-arrow" onClick={this.handleYesButtonClick}>
                                <span className="glyphicon glyphicon-menu-right" />
                                <Translate value="general.yes" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStoreToProps = (store) => {
    return {
        activeOrder: store.toDispense.activeOrder
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatchCloseDeleteOrderModalAction: () => {
            dispatch(navigationActions.closeModal(componentTypes.INTERGAMMA_DELETE_ORDER_MODAL));
        },
        dispatchDeleteOrderAction: (order) => {
            dispatch(actions.deleteOrder(order));
        }
    };
};

export default DeleteOrderModal = connect(mapStoreToProps, mapDispatchToProps)(DeleteOrderModal);
